/* ── Beneficio fiscal ─────────────────────────────────────────────────── */
const Fiscal = () => (
  <section className="sec fiscal" id="fiscal">
    <div className="wrap reveal"><div className="inner">
      <div>
        <div className="sec-eyebrow">Beneficio fiscal</div>
        <h2 className="sec-title">Deduce y <b>optimiza tus impuestos.</b></h2>
        <p className="sec-lead">El arrendamiento automotriz puro (leasing) te ayuda a deducir tus rentas conforme a la ley y a optimizar tus impuestos. Elige el plan ideal para ti, tu PyME o como PFAE — te explicamos cuál te conviene, sin tecnicismos.</p>
        <div className="sello"><span className="mx"><i></i><i></i><i></i></span><span className="txt">Empresa 100% mexicana<span>Hacemos las cosas bien.</span></span></div>
      </div>
      <div className="planos">
        <div className="plan-card fin"><div className="top"><span className="pill">Financiero</span><span className="who">No es tu prioridad deducir impuestos</span></div><div className="desc">Al final del plazo el <b>auto puede ser tuyo</b>. Ideal si buscas quedarte con el coche y mantener pagos claros mes con mes.</div></div>
        <div className="plan-card pur"><div className="top"><span className="pill">Puro</span><span className="who">Quieres reducir el pago de impuestos</span></div><div className="desc">Pensado para <b>maximizar tu beneficio fiscal</b>. La opción favorita de empresas y personas morales que quieren optimizar su carga tributaria.</div></div>
      </div>
    </div></div>
  </section>
);

export default Fiscal;
